import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { makeReference } from '@apollo/client';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Box, IconButton } from '@mui/material';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../tooltip';
import { setVisibilityFailure, setVisibilitySuccess } from './alerts';
import { useSetSocialVisibility } from './mutations';
import { jsx as _jsx } from "react/jsx-runtime";

var PureVisibilityButton = function PureVisibilityButton(_ref) {
  var visible = _ref.visible,
      setVisibility = _ref.setVisibility,
      t = _ref.t;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: visible ? t('Visible on profile') : t('Hidden from profile'),
    "data-element": "Tooltip",
    "data-component": "PureVisibilityButton",
    "data-source-file": "visibility-button.tsx",
    children: /*#__PURE__*/_jsx(IconButton, {
      sx: {
        mr: 1,
        '&:hover': {
          backgroundColor: 'transparent'
        }
      },
      onClick: function onClick() {
        return setVisibility();
      },
      "data-element": "IconButton",
      "data-component": "PureVisibilityButton",
      "data-source-file": "visibility-button.tsx",
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex'
        },
        "data-element": "Box",
        "data-component": "PureVisibilityButton",
        "data-source-file": "visibility-button.tsx",
        children: visible ? /*#__PURE__*/_jsx(VisibilityIcon, {
          sx: {
            color: function color(t) {
              return t.palette.primary.main;
            }
          }
        }) : /*#__PURE__*/_jsx(VisibilityOffIcon, {
          sx: {
            color: function color(t) {
              return t.palette.neutral.light;
            }
          }
        })
      })
    })
  });
};

var useProps = function useProps(_ref2) {
  var _ref2$social = _ref2.social,
      id = _ref2$social.id,
      visible = _ref2$social.visible,
      __typename = _ref2$social.__typename;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useSetSocialVisibili = useSetSocialVisibility({
    onCompleted: E.match(function () {
      return showAlert(setVisibilityFailure(t));
    }, function (_ref3) {
      var __typename = _ref3.setSocialVisibility.__typename;
      return __typename === 'SetSocialVisibilityResult' ? showAlert(setVisibilitySuccess(t)) : showAlert(setVisibilityFailure(t));
    }),
    update: function update(cache, data) {
      return pipe(data, E.match(function (e) {
        return console.error(e);
      }, function (_ref4) {
        var setSocialVisibility = _ref4.setSocialVisibility;
        return setSocialVisibility.__typename === 'SetSocialVisibilityResult' && cache.modify({
          id: cache.identify(makeReference("".concat(__typename, ":").concat(id))),
          fields: {
            visible: function visible(cachedValue) {
              var _setSocialVisibility$, _setSocialVisibility$2;

              return (_setSocialVisibility$ = (_setSocialVisibility$2 = setSocialVisibility.authVisibility) === null || _setSocialVisibility$2 === void 0 ? void 0 : _setSocialVisibility$2.visible) !== null && _setSocialVisibility$ !== void 0 ? _setSocialVisibility$ : !cachedValue;
            }
          }
        });
      }));
    }
  }),
      _useSetSocialVisibili2 = _slicedToArray(_useSetSocialVisibili, 1),
      setSocialVisibility = _useSetSocialVisibili2[0];

  return {
    setVisibility: function setVisibility() {
      return setSocialVisibility({
        variables: {
          input: {
            id: id,
            visible: !visible
          }
        }
      });
    },
    visible: visible,
    t: t
  };
};

export default Object.assign(flow(useProps, PureVisibilityButton), {
  displayName: 'VisibilityButton'
});